import { LoginPage } from "@/features/auth/pages/LoginPage";
import {
	type LoginPasswordMode,
	toLoginPasswordMode,
} from "@/features/auth/usecases/passwordMode";
import { createFileRoute } from "@tanstack/react-router";

const VENDOR_PATH_PREFIX = "/vendor";

type LoginSearch = { redirect?: string; pw?: LoginPasswordMode };

export const Route = createFileRoute("/vendor/login")({
	validateSearch: (search: Record<string, unknown>): LoginSearch => ({
		redirect:
			typeof search.redirect === "string" &&
			search.redirect.startsWith(VENDOR_PATH_PREFIX)
				? search.redirect
				: undefined,
		pw: toLoginPasswordMode(search.pw),
	}),
	component: VendorLoginRoute,
});

function VendorLoginRoute() {
	const { redirect, pw } = Route.useSearch();
	return <LoginPage redirectPath={redirect} passwordMode={pw} />;
}
